import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function CircularProgressWithLabel(props) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      {/* color del fondo (track) */}
      <CircularProgress
        variant="determinate"
        value={100}
        size={45}
        sx={{
          color: '#191923',
          position: 'absolute',
        }}
      />
      {/* Progreso encima */}
      <CircularProgress
        variant="determinate"
        {...props}
        size={45}
        sx={{
          color: '#ffc107'
        }}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{ color: '#8c8c8e', fontSize: "bold" }}
        >
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

export default CircularProgressWithLabel;
